module.exports = __webpack_public_path__ + "static/media/logo-svg.cd27497a981e8ee9ee7ef2893daa5c75.svg";